import type { FaireProductEntity } from "../../entity_types/product";

export const p_yf8fghvuen: FaireProductEntity = {
  token: "p_yf8fghvuen",
  type: "product",
  name: "Super Dooper Poopers 1000 Piece Puzzle",
  brandName: "Masterpieces Puzzles",
  imageUrl:
    "https://cdn.faire.com/fastly/d8365a793afd2c01f29ddcca3aa38ba1eaeeb245eb9a1ea8a7c5055eab7b278b.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ad9dc22d1c4cafd71b1987ae4146a11ec88aa08bee2e1a385b7ca52dfa902d86.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
